<template>
  <div class="message-form">
    <el-divider />
    <el-form
      :rules="formRules"
      :model="formData"
      @submit.native.prevent="validateForm"
      ref="messageForm"
    >
      <el-form-item prop="text" :error="formErrors.text">
        <el-input type="textarea" :rows="2" v-model="formData.text" />
      </el-form-item>

      <el-button
        class="message-form__button"
        type="primary"
        type-native="submit"
        @click="validateForm"
        :disabled="isButtonDisabled('send-message') || !this.formData.text"
      >
        Send
      </el-button>
    </el-form>
  </div>
</template>

<script>
import { sendMessageToUser } from '@/api/profile.js';
import { showMessage } from '@/utils/messages.js';
import { parseErrorsByFields } from '@/utils/index.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'MessageForm',
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  mixins: [disableButton],
  data() {
    return {
      formData: { text: null },
      formErrors: { text: null },
      formRules: {
        text: [
          { required: true, trigger: 'input', message: 'Please enter message' },
        ],
      },
    };
  },
  methods: {
    parseErrorsByFields,
    async requestSendMessage() {
      this.disableButton('send-message');
      const { userId } = this;
      const { text } = this.formData;
      const { success } = await sendMessageToUser({ userId, text });
      this.enableButton('send-message');

      if (success) {
        this.$emit('update-data');
        this.clearForm();
        this.clearErrors();
      } else if (errors) {
        this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
      }
    },
    validateForm() {
      if (this.$refs.messageForm) {
        this.$refs.messageForm.validate();
      }

      const { text } = this.formData;
      if (text && text.trim()) {
        this.requestSendMessage();
      }
    },
    clearForm() {
      this.formData.text = null;
    },
    clearErrors() {
      this.formErrors.text = null;
      if (this.$refs.messageForm) {
        this.$refs.messageForm.clearValidate();
      }
    },
  },
};
</script>

<style lang="scss">
.message-form {
  &__button {
    display: block;
    margin-left: auto;
  }
}
</style>
